import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { has, find, isEmpty } from 'lodash';
import { Card, Row, Col, Form, Image, Accordion } from "react-bootstrap";

const Module = (props) => {
  const {
    title,
    depth,
    objIndex,   
    objectListItem,
    formState,
    setFormState,
    children,  
    ...rest
  } = props;

  const uniqueKey = `${objIndex}-${depth}`; 
  const [activeKey, setActiveKey] = useState(null);

  const objectsState = useSelector(state => state.objectsState);

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const handleChange = (event, id, accessType, parent_id, current = true) => {
    setObjectPermission(event, id, accessType, current);
    let objectsList = objectsState.objectsList;
    if (!isEmpty(parent_id) && accessType === 'view' && event.target.checked) {
      let item = find(objectsList, { 'id': parent_id });
      handleChange(event, item.id, accessType, item.parent_id, false);
    }
  };

  const setObjectPermission = (event, id, accessType, current) => {
    const existingRights = formState.values.role_access_rights?.[id] || {};
    let a_type = !existingRights[accessType];
    if (!current) a_type = true;

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        role_access_rights: {
          ...formState.values.role_access_rights,
          [id]: {
            ...existingRights,
            [accessType]: a_type,
          }
        }
      }
    }));
  };

  

  return (
    <Card>
      <Card.Header>
        <Row className="align-items-center py-1">
          <Col lg={7}>
            <span className="font-14 font-weight-medium">{title}</span>
          </Col>
          <Col lg={3}>
            <span className="font-14 font-weight-medium">
              <Form>
                <div className="Add-role-checkbox d-flex align-items-center justify-content-center">
                  <Form.Check
                    type={'checkbox'}
                    id={`default-checkbox`}
                    checked={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['view'] : false}
                    onChange={(event) => handleChange(event, objectListItem.id, 'view', objectListItem.parent_id)}
                  />{" "}
                  <label className="ms-2">view</label>
                </div>
              </Form>
            </span>
          </Col>
          {children ? (
            <Col lg={2} className="text-end">
              <span onClick={() => toggleAccordion(uniqueKey)} className="cursor-pointer">
                {activeKey === uniqueKey ? (
                  <Image src="/assets/images/accordian-open-icon.svg" />
                ) : (
                  <Image src="/assets/images/accordian-close-icon.svg" />
                )}
              </span>
            </Col>
          ) : null}
        </Row>
      </Card.Header>
      {children ? (
        <Accordion activeKey={activeKey}>
          <Accordion.Collapse eventKey={uniqueKey}>
            <div>{children}</div>
          </Accordion.Collapse>
        </Accordion>
      ) : null}
    </Card>
  );
};

export default Module;
